import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StandardPageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Standard Page Header Component
 * 
 * Simple, clean header with left-aligned text.
 * This is the standard header format for all main pages in Hivetivity.
 */
export const StandardPageHeader: React.FC<StandardPageHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  actions,
  className
}) => {
  return (
    <div className={cn("sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-gray-200/60 shadow-sm", className)}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left: Icon + Title + Subtitle */}
          <div className="flex items-center space-x-3">
            {Icon && (
              <div className="p-2 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl shadow-lg">
                <Icon className="h-6 w-6 text-white" />
              </div>
            )}
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-gray-900 text-left">
                {title}
              </h1>
              {subtitle && (
                <p className="text-sm text-gray-600 text-left">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          
          {/* Right: Actions */}
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StandardPageHeader;